import { EmotionJSX } from '@emotion/react/types/jsx-namespace';

import { SubscriptionResponseV2 } from 'src/types/subscription';
import { CLOUDINARY_IMAGE_URL } from 'src/utils/constants/ApiConstants';
import { getExpiryDateV2 } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import {
  Title,
  ValidTimeText,
  PlanCardWrapper,
  LeftSection,
  Details,
  Logo,
  DeviceInfo,
  RightSection,
  PremiumPlanCardWrapper,
  ValidTime,
  CurrentPlanBadge,
  RadioCircleWrapper
} from './style';
import { useAppStore } from '../../../../hooks/useAppStore';
import Feature from '../Feature';

type ActivePlanProps = {
  data: Partial<SubscriptionResponseV2.Plan>;
  isAtBestPlan: boolean;
};
const SubscribedPlanCard = ({
  data,
  isAtBestPlan
}: ActivePlanProps): EmotionJSX.Element => {
  const { translations = {}, subscriptionData } = useAppStore();
  const subscriptionStrings = translations.subscription ?? {};
  const { active, features = [] } = data;
  const { title: optionTitle = '', titleTk: optionTitleTk } = data ?? {};
  const [, featureItem] = features || [];

  const expiryDate = getExpiryDateV2(
    subscriptionData?.maxPricePack?.subscription_end
  );

  const validityText = subscriptionStrings?.CMS_CURRENT_PLAN_EXPIRES_ON_TEXT;
  return (
    <PlanCardWrapper css={[isAtBestPlan && PremiumPlanCardWrapper]}>
      <LeftSection>
        <RadioCircleWrapper>
          <img
            src="/webapp-assets/images/subscription-premium.svg"
            alt="image"
          />
        </RadioCircleWrapper>
        <Details>
          <Logo>
            <img
              src={`${CLOUDINARY_IMAGE_URL}${data?.unselectedPlanImages?.desktopSmall}`}
              alt=""
            />
            <CurrentPlanBadge>
              <span>{subscriptionStrings?.CMS_CURRENT_PLAN_LABEL_TEXT}</span>
            </CurrentPlanBadge>
          </Logo>

          <Title>
            {' '}
            {optionTitleTk && subscriptionStrings[optionTitleTk]
              ? subscriptionStrings[optionTitleTk]
              : optionTitle}
          </Title>
          <DeviceInfo>
            {featureItem && (
              <Feature item={featureItem} active={active ?? false} />
            )}
            {data.deviceCount && <span>{data.deviceCount} Devices</span>}
            <span>
              •{' '}
              {data?.adEnabled
                ? subscriptionStrings?.CMS_PLAN_LIMITED_AD_TEXT
                : subscriptionStrings?.CMS_PLAN_AD_FREE_TEXT}
            </span>
          </DeviceInfo>
        </Details>
      </LeftSection>
      <RightSection>
        <ValidTimeText data-test-id={`best-plan-validity`}>
          {validityText}
          <ValidTime>{expiryDate}</ValidTime>
        </ValidTimeText>
      </RightSection>
    </PlanCardWrapper>
  );
};

export default SubscribedPlanCard;
